const Me = {
  name: "Chun Yen Chang-Sundin",
  intro:
    "Hello! I am a software engineer in Health Research, Inc. I’m always excited to explore modular ways to solve problems, especially when it leads to cleaner architecture and convey stronger business logic. I also maintain and implement Knowledge Forum 6.",
  badgeLinks: {
    github: {
      img: "https://img.shields.io/badge/jerrisonchang-000000?style=flat&logo=github&logoColor=white",
      link: "https://github.com/JerrisonChang",
    },
    linkedin: {
      img: "https://img.shields.io/badge/chunyen--cs-0077B5?style=flat&logo=linkedin&logoColor=white",
      link: "https://www.linkedin.com/in/chunyen-cs/",
    },
  },
  updatedDate: new Date("2025-12-07T16:40:00-05:00"),
};

export default Me;
